const storeName = 'MODIFACE';

export default {
    INIT_FACE_CHOICE: `${storeName}.INIT_FACE_CHOICE`,
    SET_FACES: `${storeName}.SET_FACES`,
    START_MODE: `${storeName}.START_MODE`,
    SET_LOADING: `${storeName}.SET_LOADING`,
    GET_MAKEUP_PRODUCT_DATA: `${storeName}.GET_MAKEUP_PRODUCT_DATA`,
    SET_MAKEUP_PRODUCT_DATA: `${storeName}.SET_MAKEUP_PRODUCT_DATA`,
    SET_LIBRARY_INITIALIZED: `${storeName}.SET_LIBRARY_INITIALIZED`,
    SET_CURRENT_SHADE: `${storeName}.SET_CURRENT_SHADE`,
    ON_ACTION_CLICK: `${storeName}.ON_ACTION_CLICK`,
    LIBRARY_ERROR: `${storeName}.LIBRARY_ERROR`,
    MODIFACE_ERROR: `${storeName}.MODIFACE_ERROR`,
    RESET_MODIFACE_ERROR: `${storeName}.RESET_MODIFACE_ERROR`,
    ON_SHADE_TOGGLE: `${storeName}.ON_SHADE_TOGGLE`,
};
